<template>
 
   <v-layout align-start>
    <v-flex>
        <v-toolbar text color="white">
            <v-toolbar-title>Estrategias</v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <v-spacer></v-spacer>

                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-3" v-on="on">Nueva Estrategia</v-btn>
                    </template>

                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        

                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
                                        <v-col cols="12" sm="4" md="3">
                                            <v-text-field v-model="codigo_estrategia" label="Codigo Estrategia"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="nombre_estrategia" label="Nombre Estrategia"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="3" md="5">
                                            <v-text-field v-model="beneficio_estrategia" label="Beneficio"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="3" md="5">
                                            <v-text-field v-model="indicador_estrategia" label="Indicador"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="3" md="5">
                                            <v-text-field v-model="meta_estrategia" label="Meta"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="3" md="5">
                                            <v-text-field v-model="codigo_responsable_estrategia" label="Codigo Responsable"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="3" md="5">
                                            <v-text-field v-model="orden_estrategia" label="Orden"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-flex xs12 sm12 md12 v-show="valida">
                                        <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="ble darken-1" text @click.native="close">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click.native="guardar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>cd
                </v-dialog>
 
                 <v-dialog v-model="adModal" max-width="290">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item? </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item? </v-card-title>
                    <v-card-text>
                        Estas a punto del
                        <span v-if="adAccion==1">Activar </span>
                        <span v-if="adAccion==2">Desactivar </span>
                        el item {{ adIdEstrategia}}    
                    </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                    Cancelar
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activar">
                                    Activar
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="desactivar">
                                    Desactivar
                                </v-btn>
                            </v-card-actions>                    
 

                    </v-card>            
                </v-dialog>
            </v-toolbar>

   <v-data-table
        :headers="headers"
        :items="estrategia"
        :search="search"
        class="elevation-1"
    >     
                <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                    >
                        mdi-grease-pencil
                    </v-icon>
                    <template v-if="item.estado_estrategia">
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(2,item)"
                        >
                            mdi-block-helper
                        </v-icon>
                    </template>
                    <template v-else>
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(1,item)"
                        >
                            mdi-check-all
                        </v-icon>
                    </template>
                </template>

                <template slot="items" slot-scope="props">
                    <td>{{ props.item.codigo_estrategia }}</td>
                    <td>{{ props.item.nombre_estrategia }}</td>
                    <td>{{ props.item.beneficio_estrategia }}</td>
                    <td>{{ props.item.indicador_estrategia }}</td>
                    <td>{{ props.item.meta_estrategia }}</td>
                    <td>{{ props.item.codigo_responsable_estrategia }}</td>
                    <td>{{ props.item.orden_estrategia }}</td>
                    <td>
                        <div v-if="props.item.estado_estrategia">
                            <span class="blue--text">Activo</span>
                        </div>
                        <div v-else>
                            <span class="red--text">Inactivo</span>
                        </div>
                    </td>
                </template>

                <template slot="no-data">
                <v-btn color="primary" @click="listar">Resetear</v-btn>
                </template>
    </v-data-table>

        </v-flex>
    </v-layout>

</template>

<script>
import axios from 'axios'

export default {
    data(){
        return{
                estrategia:[],                
                dialog: false,
                headers: [
                    { text: 'Opciones', value: 'action', sortable: false},
                    { text: 'Codigo Estrategia', value: 'codigo_estrategia' },
                    { text: 'Estrategia', value: 'nombre_estrategia' , sortable: false},
                    { text: 'Beneficio', value: 'beneficio_estrategia', sortable: false },
                    { text: 'Indicador', value: 'indicador_estrategia', sortable: false },
                    { text: 'Meta', value: 'meta_estrategia', sortable: false },
                    { text: 'Responsable', value: 'codigo_responsable_estrategia', sortable: false },
                    { text: 'Orden', value: 'orden_estrategia', sortable: false },
                    { text: 'Estado', value: 'estado_estrategia', sortable: false }
                ],
                search: '',
                editedIndex: -1,
                codigo_estrategia: '',
                nombre_estrategia: '',
                beneficio_estrategia: '',
                indicador_estrategia: '',
                meta_estrategia: '',
                codigo_responsable_estrategia: '',
                orden_estrategia: '',
                valida: 0,
                validaMensaje:[],
                adModal: 0,
                adAccion: 0,
                adIdEstrategia:'',
                adNombreEstrategia:''
        }
    },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nueva Estrategia' : 'Actualizar Estrategia'
            }
        },


    watch: {
        dialog (val) {
        val || this.close()
        },
    },

    created () {
        this.listar();
    },
    methods:
    {
		listar(){
			let me=this;
			axios.get('api/Estrategias/Listar').then(function(response){
				//console.log(response);
				me.estrategia=response.data;
			}).catch(function(error){
				console.log(error);   
			});
		},

		editItem (item) {
            this.codigo_estrategia=item.codigo_estrategia;
			this.nombre_estrategia=item.nombre_estrategia;
			this.beneficio_estrategia=item.beneficio_estrategia;
			this.indicador_estrategia=item.indicador_estrategia;
			this.meta_estrategia=item.meta_estrategia;
			this.codigo_responsable_estrategia=item.codigo_responsable_estrategia;
			this.orden_estrategia=item.orden_estrategia;
            this.editedIndex=1;            
			this.dialog = true
		},

		deleteItem (item) {
		const index = this.estrategia.indexOf(item)
		confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
		},

		close () {
            this.dialog = false;
            this.limpiar();
		},

		limpiar(){
			this.codigo_estrategia="";
			this.nombre_estrategia="";
			this.beneficio_estrategia="";
			this.indicador_estrategia="";
			this.meta_estrategia="";
			this.codigo_responsable_estrategia="";
			this.orden_estrategia="";
			this.editedIndex=-1;
		},

		guardar () {
			if(this.validar()){
				return;
			}
			if (this.editedIndex > -1) {
				// codigo para guardar
				let me=this;
				axios.put('api/Estrategias/Actualizar',{
					'codigo_estrategia': me.codigo_estrategia,
                    'nombre_estrategia': me.nombre_estrategia,
                    'beneficio_estrategia': me.beneficio_estrategia,
                    'indicador_estrategia': me.indicador_estrategia,
                    'meta_estrategia': me.meta_estrategia,
                    'codigo_responsable_estrategia': me.codigo_responsable_estrategia,
                    'orden_estrategia': me.orden_estrategia
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});

			} else {
		   //     this.desserts.push(this.editedItem)
				let me=this;
				axios.post('api/Estrategias/Crear',{
					'codigo_estrategia': me.codigo_estrategia,
                    'nombre_estrategia': me.nombre_estrategia,
                    'beneficio_estrategia': me.beneficio_estrategia,
                    'indicador_estrategia': me.indicador_estrategia,
                    'meta_estrategia': me.meta_estrategia,
                    'codigo_responsable_estrategia': me.codigo_responsable_estrategia,
                    'orden_estrategia': me.orden_estrategia
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});
			}
		},
		validar(){
			this.valida=0;
			this.validaMensaje=[];
			if(this.nombre_estrategia.length < 3 || this.nombre_estrategia.length > 100){
				this.validaMensaje.push("El nombre estrategia debe tener mas de 3 caracteres y menos de 100 caracteres");
			}
			if(this.beneficio_estrategia.length < 3 || this.beneficio_estrategia.length > 100){
				this.validaMensaje.push("El beneficio estrategia debe tener mas de 3 caracteres y menos de 100 caracteres");
            }
            if(!this.codigo_responsable_estrategia){
				this.validaMensaje.push("Seleccione un Responsable de Estrategia");
            }            
		    if(this.validaMensaje.length){
				this.valida=1;
			}
		    return this.valida;
        },
        activarDesactivarMostrar(accion,item){
        this.adModal=1;
        this.adIdEstrategia=item.codigo_estrategia;
        if (accion==1){
            this.adAccion=1;
        }
        else if (accion==2){
        this.adAccion=2;
        }
        else{
        this.adModal=0;
        }
        },
        activarDesactivarCerrar(){
        this.adModal=0;
        },
        activar(){
            let me=this;
            axios.put('api/Estrategias/Activar/'+this.adIdEstrategia,{}).then(function(response){
            me.adModal=0;
            me.adAccion=0;
            me.adNombreEstrategia="";
            me.adIdEstrategia="";
            me.listar();                       
            }).catch(function(error){
                console.log(error);
            });
        },
        desactivar(){
            let me=this;
            axios.put('api/Estrategias/Desactivar/'+this.adIdEstrategia,{}).then(function(response){
                me.adModal=0;
                me.adAccion=0;
                me.adId="";
                me.adNombreEstrategia="";
                me.listar();                       
            }).catch(function(error){
            console.log(error);
        });
            }
        }        
    }
</script>